import { Popconfirm } from "ant-design-vue";
const { ...other } = Popconfirm;
const YwPopconfirm = {
	...other,
	name: "YwPopconfirm",
};

YwPopconfirm.install = function (Vue) {
	Vue.component(YwPopconfirm.name, Popconfirm);
};

export default YwPopconfirm;
